/**
 * Expands and HTMLElement height
 * @param {HTMLElement} element
 * @return {void}
 */
export default function expand(element) {
    // Get the height of the element's inner content, regardless of its actual size
    const sectionHeight = element.scrollHeight;
    // have the element transition to the height of its inner content
    element.style.height = sectionHeight + 'px';
    // when the next css transition finishes (which should be the one we just triggered)
    const transitionend = () => {
        // remove this event listener so it only gets triggered once
        element.removeEventListener('transitionend', transitionend);
        // remove "height" from the element's inline styles, so it can return to its initial value
        element.style.height = 'auto';
    };
    element.addEventListener('transitionend', transitionend, false);
    // mark the section as "currently not collapsed"
    element.setAttribute('data-collapsed', 'false');
}
